'use client';

import Link from 'next/link';
import './attractions.css';

export default function AttractionsError({ reset }: { error: Error; reset: () => void }) {
  return (
    <div className="atr-page">
      <div className="atr-container" style={{ padding: '80px 20px', textAlign: 'center' }}>
        <h1 className="atr-h1">Something went wrong</h1>
        <p className="atr-muted" style={{ margin: '12px 0 28px' }}>
          We couldn’t load this page. Please try again.
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          <button type="button" className="atr-btn atr-btn-primary" onClick={reset}>
            Try again
          </button>
          <Link href="/attractions-experiences" className="atr-btn atr-btn-ghost">
            Back to attractions
          </Link>
        </div>
      </div>
    </div>
  );
}
